import { Grid, Typography } from "@mui/material";

import Select from "components/Select";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";

function WithdrawTypeSelect({ withdrawInitial, selectedCoin }) {
  const { watch, setValue } = useFormContext();
  const typeId = watch("typeId");

  const types = useMemo(() => {
    const allowedTypes = withdrawInitial?.lisType?.filter(
      (type) => type.coinId === selectedCoin?.id
    );

    setValue("typeId", allowedTypes?.[0]?.id);

    return allowedTypes;
  }, [withdrawInitial, selectedCoin, setValue]);

  const handleChangeType = (e) => {
    const val = e?.target?.value;

    setValue("address", "");
    setValue("tagOrMemo", "");
    setValue("proposal", "");
    setValue("amount", "");
    setValue("typeId", val);
  };

  return (
    <Grid item xs={12}>
      <Typography variant="h6" color="text.main">
        Type
      </Typography>

      <Select
        items={types}
        itemText="name"
        itemValue="id"
        value={typeId}
        dir="ltr"
        onChange={handleChangeType}
      />
    </Grid>
  );
}

export default WithdrawTypeSelect;
